import { all, call } from 'redux-saga/effects'
import { APIS, INSIGHT_COPILOT_PROJECT_KEYS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { addQueryParamsToAPI } from '../../_common/functions'
import { trackError } from '../../utils/analytics/rumTracking'

export function* conversation<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const { access_token, ...data } = action.payload
        const resp = yield call(CallApi.POST, APIS.TESTOPS_GENIE.CONVERSATION, data || {}, true, () => {}, access_token)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to process conversation',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'conversation', action: action?.type })
    }
}

export function* chat<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const { conversation_id, query, access_token, project_key } = action.payload as { conversation_id: string; query: string; [key: string]: any }
        const resp = yield call(CallApi.POST, APIS.TESTOPS_GENIE.CHAT(conversation_id), { query, project_key }, true, () => {}, access_token)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to process chat',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'chat', action: action?.type })
    }
}

export function* getChatByConversationID<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const { project_key, ...data } = action.payload as any
        const API = addQueryParamsToAPI(APIS.TESTOPS_GENIE.GET_CHAT_BY_CONVERSATION_ID, { project_key })
        const resp = yield call(CallApi.POST, API, data || {}, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to get chat by conversation ID',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getChatByConversationID', action: action?.type })
    }
}
export function* getSuggestedQuestions<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.TESTOPS_GENIE.GET_SUGGESTED_QUESTIONS, {}, false, true)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to get suggested questions',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getSuggestedQuestions', action: action?.type })
    }
}
export function* addUser<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const projectKeys = Object.values(INSIGHT_COPILOT_PROJECT_KEYS)
        const responses = yield all(projectKeys.map((product_key) => call(CallApi.POST, APIS.TESTOPS_GENIE.ADD_USER, { ...action.payload, product_key }, true, (e: any) => {}, action.payload.access_token)))

        const failed = responses.find((r: any) => !(r?.status >= 200 && r?.status < 300 && r?.data))
        if (failed) {
            action?.onError(failed.data as ErrorResponse<R>)
        } else {
            action?.onSuccess(responses[responses.length - 1].data as SuccessResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to add user',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'addUser', action: action?.type })
    }
}
export function* getConversationList<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const { access_token, ...data } = action.payload as { access_token: string; page: number; page_size: number; [key: string]: any }
        const resp = yield call(CallApi.GET, APIS.TESTOPS_GENIE.GET_CONVERSATION_LIST, data || {}, true, true, () => {}, access_token)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to get conversation list',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getConversationList', action: action?.type })
    }
}
export function* getChatHistory<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    const { conversationID, access_token, ...data } = action.payload as any
    try {
        const resp = yield call(CallApi.GET, APIS.TESTOPS_GENIE.GET_HISTORY(conversationID), data, true, true, () => {}, access_token)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to get chat history',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getChatHistory', action: action?.type })
    }
}
export function* chatSocket<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    const { access_token, ...data } = action.payload as any
    try {
        const resp = yield call(CallApi.GET, APIS.TESTOPS_GENIE.CHAT_SOCKET, data || {}, true, true, () => {}, access_token)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        // ✅ CHANGED: Added optional chaining to e.message
        action?.onError({
            message: e?.message || 'Failed to get chat history',
            status_code: 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'chatSocket', action: action?.type })
    }
}
